import React from 'react'

const HealthCheck = () => {
  return <div>Your app is healthy!</div>
}

export default HealthCheck
